// 各社ポータル: 資料詳細＋原本PDF閲覧(Worker経由でPDFバイト列を取得し、Blob URLとして開く)。
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiGet, apiGetBlob, ApiError } from "../lib/api";
import { MaterialSheet } from "../components/MaterialSheet";
import type { Material } from "../types";

export function PortalDetail() {
  const { companyId, materialId } = useParams();
  const [material, setMaterial] = useState<Material | null>(null);
  const [loading, setLoading] = useState(true);
  const [pdfError, setPdfError] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    apiGet<{ materials: Material[] }>(`/api/portal/materials?companyId=${encodeURIComponent(companyId)}`)
      .then((r) => setMaterial(r.materials.find((m) => m.id === materialId) || null))
      .finally(() => setLoading(false));
  }, [companyId, materialId]);

  const openPdf = async () => {
    if (!materialId) return;
    setPdfLoading(true);
    setPdfError("");
    try {
      const blob = await apiGetBlob(`/api/portal/pdf?materialId=${encodeURIComponent(materialId)}`);
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener");
    } catch (e) {
      setPdfError(e instanceof ApiError ? e.message : "PDFの取得に失敗しました");
    } finally {
      setPdfLoading(false);
    }
  };

  if (loading) return <div className="card">読み込み中…</div>;
  if (!material) return <div className="card">資料が見つかりません(未配信または権限がありません)。</div>;

  return (
    <div className="card">
      <div className="row no-print" style={{ justifyContent: "space-between", marginBottom: 12 }}>
        <Link to=".." className="btn ghost sm">
          ← 一覧へ戻る
        </Link>
        {material.sourcePdfPath && (
          <button className="btn sec sm" onClick={openPdf} disabled={pdfLoading}>
            📄 元PDFを開く
          </button>
        )}
      </div>
      {pdfError && <div className="banner">{pdfError}</div>}
      <div className="preview-wrap">
        <MaterialSheet material={material} />
      </div>
    </div>
  );
}
